import * as tslib_1 from "tslib";
import { Actions, Effect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import * as fromCustomer from '../reducers';
import * as customer from '../actions/customer';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CustomersService } from '../services/customers.service';
import { withPredicateFrom } from '../../core/helpers/rx-pipes';
var CustomerEffects = /** @class */ (function () {
    function CustomerEffects(actions$, store, customerService) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.customerService = customerService;
        this.getCustomers$ = this.actions$.ofType(customer.GET)
            .pipe(switchMap(function () {
            return _this.customerService.getCustomers()
                .pipe(map(function (customers) { return new customer.GetSuccess(customers); }), catchError(function (e) { return of(new customer.GetFailed(e)); }));
        }));
        this.expand$ = this.actions$.ofType(customer.EXPAND)
            .pipe(withPredicateFrom(this.store.pipe(select(fromCustomer.customersCanExpand)), function (canExpand) { return canExpand; }), withLatestFrom(this.store.pipe(select(fromCustomer.getCustomerSearchTerm)), this.store.pipe(select(fromCustomer.getNextCustomerPage)), function (action, searchTerm, nextPage) { return ({ searchTerm: searchTerm, nextPage: nextPage }); }), switchMap(function (data) {
            return _this.customerService.getCustomers(data.nextPage, data.searchTerm)
                .pipe(map(function (customers) { return new customer.ExpandSuccess(customers); }), catchError(function (e) { return of(new customer.ExpandFailed(e)); }));
        }));
        this.search$ = this.actions$.ofType(customer.SEARCH)
            .pipe(withLatestFrom(this.store.pipe(select(fromCustomer.getCustomerSearchTerm)), this.store.pipe(select(fromCustomer.getNextCustomerPage)), function (action, searchTerm, nextPage) { return ({ searchTerm: searchTerm, nextPage: nextPage }); }), switchMap(function (data) {
            return _this.customerService.getCustomers(1, data.searchTerm)
                .pipe(map(function (customers) { return new customer.SearchSuccess(customers); }), catchError(function (e) { return of(new customer.SearchFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "getCustomers$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "expand$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CustomerEffects.prototype, "search$", void 0);
    return CustomerEffects;
}());
export { CustomerEffects };
